import {
  getIsOperatorFromSelector,
  getQuotation,
} from 'app/services/businessFunctionHelpers';
import { RenewalChangedAddressEnum } from 'app/shared/enums';

export const addRenewalChangedAddress = (
  initialRun: boolean,
  changedAddress: RenewalChangedAddressEnum
) => {
  const quotation = getQuotation();
  const isRenewal = !!(quotation.renewal || quotation.externalRenewal);
  const isOperator = getIsOperatorFromSelector();

  if (initialRun || !isRenewal || isOperator) return;

  const currentChangedAddresses =
    sessionStorage.getItem('renewalChangedAdresses') || '';

  if (!currentChangedAddresses.includes(changedAddress))
    sessionStorage.setItem(
      'renewalChangedAdresses',
      `${currentChangedAddresses}${changedAddress},`
    );
};
